import type { ClientOverviewRepository } from "../repositories/ClientOverviewRepository";
import type { LastMonthExpenseInsightsEntity } from "../entities/LastMonthExpenseInsightsEntity";

export class GetLastMonthExpenseInsightsUseCase {
  constructor(private readonly repository: ClientOverviewRepository) {}

  async execute(): Promise<LastMonthExpenseInsightsEntity> {
    return this.repository.getLastMonthExpenseInsights();
  }
}
